// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2CVWu","card":"styles_card__37tRD","title":"styles_title__5DTzN","description":"styles_description__1B60v"};